import ConnectedAppRestService from './ConnectedAppRestService'
import { TFunction } from 'i18next'
import AppRestService from '../../../gateway/rest/AppRestService'

class ConnectedAppService {
  private static async updateAppConfiguration(appId: number, createdApp: any) {
    if (createdApp.consumerKey) {
      const appConfiguration = await AppRestService.getById(appId)

      appConfiguration.clientid = createdApp.consumerKey

      if (!appConfiguration.logindns) {
        appConfiguration.logindns = createdApp.loginHost
      }

      await AppRestService.update(appConfiguration)
    }
  }

  static async createConnectedApp(connectedApp: any, appId: number, t: TFunction) {
    try {
      const createdApp = await ConnectedAppRestService.create(connectedApp)
      await ConnectedAppService.updateAppConfiguration(appId, createdApp)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default ConnectedAppService
